import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'

import { clearTemporaryStorage, regexPhoneNumber } from 'helpers/helpers'

import { ReactComponent as LanguageIcon } from 'assets/icons/header/language.svg';
import { ReactComponent as ArrowIcon } from 'assets/icons/header/arrow_bottom.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/header/profile.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/header/email.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/header/phone.svg';
import { ReactComponent as LogoutIcon } from 'assets/icons/header/logout.svg';
import { ReactComponent as SettingsIcon } from 'assets/icons/header/settings.svg';
import logo from "assets/images/logo.png";
import { httpOk, POST } from "helpers/api";
import ConfirmModal from "components/ConfirmModal";
import useDidMountEffect from "components/useDidMountEffect";

function Header() {
	const { i18n, t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const reduxAccount = useSelector(state => state.account)

	// const wrapperRef = useRef(null);
	const languageRef = useRef(null);
	useOutsideAlerter(languageRef);

	const languages = [
		{
			id: 'RU',
			name: 'Русский',
		},
		{
			id: 'UZ',
			name: "O'zbekcha",
		},
		{
			id: 'EN',
			name: 'English',
		},
		{
			id: 'TR',
			name: 'Türkçe',
		},
	];

	const [modalLogout, setModalLogout] = useState(false)
	const [userModal, setUserModal] = useState(false)
	const [showLanguageDropdown, setShowLanguageDropdown] = useState(false)
	const [confirmModal, setConfirmModal] = useState(false)

	const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'RU')

	async function logout() {
		const response = await POST('/users/logout/', {
			refresh: reduxAccount.refresh
		})
		if (httpOk(response)) {
			dispatch({ 'type': 'USER_LOGGED_OUT', payload: null })
			clearTemporaryStorage()
			navigate('/auth/login')
		}
	}

	function changeLanguage(item) {
		i18n.changeLanguage(item.id.toLowerCase()) // i18next обычно использует строчные 'ru', 'en'
		localStorage.setItem("language", item.id)
		setSelectedLanguage(item.id)
		setShowLanguageDropdown(false)
		window.location.reload();
	}

	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowLanguageDropdown(false)
				}
			}
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}

	useDidMountEffect(() => {
		if (confirmModal) {
			setUserModal(false)
		} else {
			setUserModal(true)
		}
	}, [confirmModal]);

	return (
		<>
			<header>
				<div className="title">
					<img src={logo} alt="logo" />
					NEHIR
				</div>

				<div className="d-flex align-items-center gap-16">

					{/* <div className="position-relative">
						<input
							type="text"
							name="search"
							className="search"
							placeholder={t('search_by_name_or_code')}
						/>
						<SearchIcon className="search-icon" />
					</div> */}

					{/* {reduxAccount.role === 'MANAGEMENT' &&
						<div style={{ width: '300px' }}>
							<CustomSelect
								options={warehouses}
								// value={warehouses.find(option => option.id === filterData?.product_id) || ''}
								// onChange={(option) => setFilterData({ ...filterData, product_id: option?.id })}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
								placeholder={t('warehouse')}
								isClearable={false}
							/>
						</div>
					} */}

					<div className="dropdown language" onClick={() => setShowLanguageDropdown(!showLanguageDropdown)} ref={languageRef}>
						<LanguageIcon className="icon" />
						{selectedLanguage}
						<ArrowIcon className="arrow" />

						<div className={`menu ${showLanguageDropdown ? 'show' : ''}`}>
							{languages.map((item, index) => (
								<div className="item" onClick={(e) => {
									e.stopPropagation();
									changeLanguage(item);
								}} key={index}>
									{item.name}
								</div>
							))}
						</div>
					</div>

					<div className="profile" onClick={() => setUserModal(true)}>
						<ProfileIcon />
					</div>
				</div>
			</header>

			<Modal show={userModal} centered onHide={() => setUserModal(false)}>
				<i className="uil-times" onClick={() => setUserModal(false)}></i>
				<div className="modal-title mb-16">
					{t('user_profile')}
				</div>

				<div className="d-flex align-items-center gap-18">
					<div className="profile-avatar">

					</div>

					<div className="d-between align-items-start flex-column gap-5">
						<div className="fz20">
							{reduxAccount.fio}
						</div>
						<div className="text-second">
							{t('role')}: {t(reduxAccount.role?.toLowerCase())}
						</div>
						<div className={reduxAccount.is_active ? "alert-success" : "alert-danger"}>
							{reduxAccount.is_active ? t('active') : t('not_active')}
						</div>
					</div>
				</div>

				<hr />

				{(reduxAccount.email && reduxAccount.phone_number) &&
					<div>
						<div className="fz14 text-fourth mb-12">
							{t('contact_info')}
						</div>

						<div className="d-flex flex-column gap-8 ms-4">
							{reduxAccount.email &&
								<div className="d-flex align-items-center gap-12">
									<EmailIcon />
									{reduxAccount.email}
								</div>
							}
							{reduxAccount.phone_number &&
								<div className="d-flex align-items-center gap-12">
									<PhoneIcon />
									{regexPhoneNumber(reduxAccount.phone_number)}
								</div>
							}
							{/* <div className="d-flex align-items-center gap-12">
							<WarehouseIcon />
							{t('raw_material_warehouse')}
						</div> */}
						</div>
					</div>
				}


				{(reduxAccount.email && reduxAccount.phone_number) &&
					<hr />
				}

				{/* <div>
					<div className="fz14 text-fourth mb-12">
						{t('access_rights')}
					</div>

					<div className="d-flex flex-column gap-8 ms-4">
						<div className="d-flex align-items-center gap-12">
							<CircleCheckIcon />
							{t('dashboard')}
						</div>
						<div className="d-flex align-items-center gap-12">
							<CircleCheckIcon />
							{t('raw_material_warehouse')}
						</div>
					</div>
				</div> */}

				{/* <hr /> */}

				<div className="d-flex gap-8 mb-24">
					<Link to="/settings" className="w-100" onClick={() => setUserModal(false)}>
						<button className="outline">
							<SettingsIcon />
							{t('settings')}
						</button>
					</Link>

					<button className="outline danger" onClick={() => setConfirmModal(true)}>
						<LogoutIcon />
						{t('logout')}
					</button>
				</div>

				<div className="profile-info">
					<div className="d-between">
						{t('user_id')}:
						<div className="text-first">
							{reduxAccount.id}
						</div>
					</div>
					<div className="d-between">
						{t('login')}:
						<div className="text-first">
							{reduxAccount.user_name}
						</div>
					</div>
				</div>
			</Modal>

			{/* Модалка подтверждения выхода */}
			<Modal show={modalLogout} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalLogout(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('logout')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('logout_session_desc')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalLogout(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => logout()}>
							{t('sign_in')} {/* Или добавьте ключ 'confirm' в JSON */}
						</button>
					</div>
				</Modal.Footer>
			</Modal>

			<ConfirmModal modal={confirmModal} setModal={setConfirmModal} confirm={logout} />
		</>
	);
};

export default Header;